import React, { useState, useEffect } from "react";
import BillerDropdownView from "./components/BillerDropdownView";

import "./styles.css";

export default function BillerSearchField(props) {
    const [state, setState] = useState({ value: "", dropdown: false });

    const controllers = {
        "open" : () => setState({ ...state, dropdown: true }),
        "close" : () => setState({ ...state, dropdown: false }),
        "clear": () => setState({ value: "", dropdown: false }),
        "set" : value => setState({ ...state, ...value }),
        "setValue" : value => setState({ ...state, value: value }),

        "state" : state
    };
    
    return <BillerDropdownView controllers={ controllers } { ...props } />
}